import { useState } from 'react';

import { Box, Link } from '@mui/material';

import { useLocale } from '@shared/hooks/locale';

const COLLAPSED_COUNT = 3;

// Inline, inherits the surrounding font. A mass email has up to 100 addresses:
// collapsed to a few names, and scrollable once expanded.
export const CollapsibleAddressList = ({
  addresses,
}: {
  addresses: string[];
}) => {
  const { t } = useLocale();
  const [expanded, setExpanded] = useState(false);
  const hidden = addresses.length - COLLAPSED_COUNT;
  if (hidden <= 0) {
    return <>{addresses.join(', ')}</>;
  }
  const toggle = (label: string) => (
    <Link
      component="button"
      type="button"
      variant="inherit"
      underline="hover"
      onClick={() => setExpanded(!expanded)}
      sx={{ ml: expanded ? 0 : 0.5, verticalAlign: 'baseline' }}
    >
      {label}
    </Link>
  );
  if (!expanded) {
    return (
      <>
        {addresses.slice(0, COLLAPSED_COUNT).join(', ')}
        {toggle(t('+{{count}} more', { count: hidden }))}
      </>
    );
  }
  return (
    <>
      <Box
        component="span"
        sx={{ display: 'block', maxHeight: 160, overflowY: 'auto' }}
      >
        {addresses.join(', ')}
      </Box>
      {toggle(t('Show less'))}
    </>
  );
};
